import React, { useState } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Header, Subheader, Detail, NextButton, ResendButton, ButtonsContainer } from '../../../styles';

import { ConfirmEmailValues } from '..';

import { Container, ResultImage } from '../styles';

interface Props {
  confirmEmail: ConfirmEmailValues | null;
  onSubmit: () => void;
  onResend: () => Promise<void>;
}

const ConfirmEmailExists = ({ confirmEmail, onSubmit, onResend }: Props) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const { t } = useStoreTranslation();

  const handleClickResend = async () => {
    setSubmitting(true);
    await onResend();
    setSubmitting(false);
  };

  if (!confirmEmail) return null;

  return (
    <Container>
      <ResultImage src="/images/success-circle.svg" />

      <Header black>{t('login.confirmEmail.exists.title')}</Header>
      <Subheader>{confirmEmail.email}</Subheader>
      <Detail>{t('login.confirmEmail.exists.detail')}</Detail>

      <ButtonsContainer center>
        <NextButton onClick={onSubmit}>{t('login.confirmEmail.exists.confirm')}</NextButton>
        <ResendButton type="button" onClick={handleClickResend} disabled={isSubmitting} loading={isSubmitting}>
          {t('login.confirmEmail.exists.resend')}
        </ResendButton>
      </ButtonsContainer>
    </Container>
  );
};

export default ConfirmEmailExists;
